import PropTypes from 'prop-types'

import RiskAnalysisDetails from '../../../../RiskAnalysisDetails'

/**
 * Reiter „Risikoanalyse": Markt- und Risikoanalyse des Unternehmens.
 *
 * Sie stand frueher hinter einem Knopf in einem eigenen Fenster. Da sie nur
 * gelesen und nicht bearbeitet wird, gibt es keinen Grund fuer den Umweg — im
 * Reiter ist ohnehin Platz, und ein Fenster ueber einem Reiter verdeckt genau
 * das, wogegen man vergleichen will.
 */
export default function RiskTab({ riskAnalysis }) {
	return <RiskAnalysisDetails riskAnalysis={riskAnalysis} />
}

RiskTab.propTypes = {
	riskAnalysis: PropTypes.object
}
